import Api, { MyQuotesListResponse } from "../../Api";
import { useCallback, useState } from "react";
import EntitySearch from "../../parts/EntitySearch";
import EntityList from "../../parts/EntityList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge } from "./List";
import moment from "moment";

const ListAll = () => {
  const [data, setData] = useState<MyQuotesListResponse[] | null>(null);

  const search = useCallback(
    (searchTerm: string, page: string) =>
      Api.myQuotesList("all", searchTerm, page),
    []
  );
  return (
    <>
      <div className="px-4">
        <EntitySearch searchFunction={search} setEntities={setData} />
      </div>
      <EntityList entities={data} Card={QuoteLean} />
    </>
  );
};

export default ListAll;

const QuoteLean = ({
  entity: { quote, clientName },
}: {
  entity: MyQuotesListResponse;
}) => {
  return (
    <div className={"border rounded-lg shadow-sm"} key={quote.uuid}>
      <div className="p-4 flex flex-col gap-2">
        <div className="flex gap-1 overflow-scroll no-scrollbar">
          <Badge className="font-mono cursor-default">{quote.number}</Badge>

          <Badge>
            <FontAwesomeIcon icon="calendar" className="mr-2 text-gray-400" />
            {moment(quote.creationDate).format("DD/MM/YY – HH:mm")}
          </Badge>

          {!quote.isApproved && (
            <Badge className="bg-yellow-100 text-yellow-600">
              <FontAwesomeIcon icon="clock" className="mr-2" />
              Pendente
            </Badge>
          )}
        </div>

        <div className="overflow-scroll whitespace-nowrap no-scrollbar font-semibold">
          {clientName}
        </div>
      </div>

      {quote.isAuthorized && (
        <div className="text-gray-400 truncate text-xs font-light border-t px-4 py-1">
          <span className="font-semibold text-gray-500">
            <FontAwesomeIcon
              icon="check-circle"
              className="text-gray-400 mr-3"
            />
            Autorizado
          </span>
          {quote.authorizationDate && (
            <>
              {" "}
              em {moment(quote.authorizationDate).format("DD/MM/YY")} às{" "}
              {moment(quote.authorizationDate).format("HH:mm")}
            </>
          )}
        </div>
      )}
    </div>
  );
};
